export default __webpack_public_path__ + "static/media/DinosaursCarnivores_01.06145a14.png";